module.exports = __webpack_public_path__ + "img/6.0dc56a58.png";